<template>
  <MessageItem
    :date="message.createdAt"
    :userType="userType"
    :personalityType="personalityType"
    :isReadByUser="isReadByUser"
    @clickUserThumbnail="$emit('clickUserThumbnail')"
  >
    <section :class="$style.message">
      <p>{{ message.body }}</p>
      <ul :class="[$style.message__selections, $style.selections]">
        <li
          v-for="(selection, index) in message.selections"
          :key="index"
          :class="$style.selections__item"
        >
          <span>{{ selection }}</span>
        </li>
      </ul>
    </section>
  </MessageItem>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import MessageItem from '@/components/molecules/MessageItem.vue'
import type { SelectionsMessage } from '@/types/app/message'
import type { ChatMessageUserType } from './ChatMessageUserType'
import type { PersonalityType } from '@/types/app'

export default defineComponent({
  name: 'ChatMessageSelections',
  components: {
    MessageItem,
  },
  props: {
    message: {
      type: Object as PropType<SelectionsMessage>,
      required: true,
    },
    userType: {
      type: String as PropType<ChatMessageUserType>,
      required: true,
    },
    personalityType: {
      type: String as PropType<PersonalityType>,
      default: 'A',
    },
    isReadByUser: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss" module>
.message {
  padding: 24px;
  white-space: pre-wrap;
  word-break: break-all;

  a {
    color: currentcolor;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  &__selections {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.selections {
  padding-left: 1.75em;

  &__item {
    list-style: circle;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
</style>
